<template>
  <div class="container">
    <sys-loading :loading="loading" />
    <div v-if="!isMobile" class="content" @click="clickHandler($event)">
      <div class="mask" v-show="formVisible">
        <div class="form">
          <img class="close" src="../assets/new-sport/icon-close.png" />
          <div class="form-content">
            <div class="tags">
              <img
                v-show="isRegisterAction"
                src="../assets/new-sport/icon-login-n.png"
                @click="isRegisterAction = false"
              />
              <img
                v-show="!isRegisterAction"
                src="../assets/new-sport/icon-login-a.png"
                @click="isRegisterAction = false"
              />
              <img
                v-show="isRegisterAction"
                src="../assets/new-sport/icon-reg-a.png"
                @click="isRegisterAction = true"
              />
              <img
                v-show="!isRegisterAction"
                src="../assets/new-sport/icon-reg-n.png"
                @click="isRegisterAction = true"
              />
            </div>
            <div class="inputs">
              <div class="success-show" v-if="successful">
                <img
                  :src="
                    isRegisterAction
                      ? require('../assets/new-sport/success-reg.png')
                      : require('../assets/new-sport/success-login.png')
                  "
                />
                <p>
                  {{
                    isRegisterAction
                      ? "* Chúc mừng bạn đã đăng ký thành công! Tự động đăng nhập trong 5s."
                      : "* Bạn đang được chuyển về trang chủ 888b Vui lòng chờ trong 5s."
                  }}
                </p>
              </div>
              <div
                class="tao"
                v-if="!successful"
                :style="isRegisterAction ? '' : 'height: 43%;'"
              >
                <el-form :model="form" ref="form">
                  <el-form-item prop="username" :rules="userNameRule">
                    <el-input
                      v-model="form.username"
                      placeholder="Tên đăng nhập"
                      maxlength="20"
                      oninput="value=value.replace(/\W/, '')"
                      autocomplete="off"
                    ></el-input>
                  </el-form-item>
                  <el-form-item
                    prop="phone"
                    v-show="isRegisterAction"
                    :rules="isRegisterAction ? phoneRule : null"
                  >
                    <el-input
                      v-model="form.phone"
                      placeholder="Số điện thoại"
                      maxlength="11"
                      oninput="value=value.replace(/\D/, '')"
                      autocomplete="off"
                    ></el-input>
                  </el-form-item>
                  <el-form-item prop="password" :rules="passwordRule">
                    <el-input
                      type="password"
                      v-model="form.password"
                      placeholder="Mật khẩu"
                      autocomplete="off"
                    ></el-input>
                  </el-form-item>
                  <el-form-item
                    prop="email"
                    v-show="isRegisterAction"
                    :rules="isRegisterAction ? emailRule : null"
                  >
                    <el-input
                      v-model="form.email"
                      placeholder="Email"
                    ></el-input>
                  </el-form-item>
                </el-form>
                <img
                  class="btn-gif login"
                  v-show="!isRegisterAction"
                  @click="submitAction('2')"
                  src="../assets/new-sport/btn-login.gif"
                />
                <v-captcha
                  ref="vcaptcha1"
                  :dialogVisible="dialogVisible"
                  :showCheck="showCheck"
                  @cb="handleConfirm"
                  :vstyle="{ position: 'absolute', bottom: '-180px' }"
                  :nativeButton="{
                    width: '280px',
                    height: '85px'
                  }"
                >
                  <img
                    class="btn-gif"
                    v-show="isRegisterAction"
                    @click="submitAction('1')"
                    src="../assets/new-sport/btn-register.gif"
                  />
                </v-captcha>
              </div>
              <p class="error-msg">{{ errorMsg.content }}</p>
            </div>
          </div>
        </div>
      </div>
      <div class="mid">
        <div>
          <img
            v-for="idx in 5"
            :src="`${require('../assets/new-sport/icon-' + idx + '.png')}`"
          />
        </div>
        <img
          class="main-register"
          src="../assets/new-sport/main-register.gif"
        />
      </div>
      <div class="contacts">
        <a :href="fb" target="_blank"
          ><img src="../assets/new-sport/icon-fb.png"
        /></a>
        <a :href="tg" target="_blank"
          ><img src="../assets/new-sport/icon-tg.png"
        /></a>
      </div>
    </div>
    <div v-if="isMobile" class="root" @click="clickHandler($event)">
      <div class="mask" v-show="formVisible">
        <div class="form">
          <img
            class="close"
            src="../assets/new-sport/icon-close.png"
            :style="isRegisterAction ? 'bottom: -25vw;' : ''"
          />
          <div class="form-content">
            <div class="tags">
              <img
                v-show="isRegisterAction"
                src="../assets/new-sport/icon-login-n.png"
                @click="isRegisterAction = false"
              />
              <img
                v-show="!isRegisterAction"
                src="../assets/new-sport/icon-login-a.png"
                @click="isRegisterAction = false"
              />
              <img
                v-show="isRegisterAction"
                src="../assets/new-sport/icon-reg-a.png"
                @click="isRegisterAction = true"
              />
              <img
                v-show="!isRegisterAction"
                src="../assets/new-sport/icon-reg-n.png"
                @click="isRegisterAction = true"
              />
            </div>
            <div class="inputs">
              <div class="success-show" v-if="successful">
                <img
                  :src="
                    isRegisterAction
                      ? require('../assets/new-sport/success-reg-h5.png')
                      : require('../assets/new-sport/success-login-h5.png')
                  "
                />
                <p>
                  {{
                    isRegisterAction
                      ? "* Chúc mừng bạn đã đăng ký thành công! Tự động đăng nhập trong 5s."
                      : "* Bạn đang được chuyển về trang chủ 888b Vui lòng chờ trong 5s."
                  }}
                </p>
              </div>
              <div
                class="tao"
                v-if="!successful"
                :style="isRegisterAction ? '' : 'height: 43%;'"
              >
                <el-form :model="form" ref="form">
                  <el-form-item prop="username" :rules="userNameRule">
                    <el-input
                      v-model="form.username"
                      placeholder="Tên đăng nhập"
                      maxlength="20"
                      oninput="value=value.replace(/\W/, '')"
                      autocomplete="off"
                    ></el-input>
                  </el-form-item>
                  <el-form-item
                    prop="phone"
                    v-show="isRegisterAction"
                    :rules="isRegisterAction ? phoneRule : null"
                  >
                    <el-input
                      v-model="form.phone"
                      placeholder="Số điện thoại"
                      maxlength="11"
                      oninput="value=value.replace(/\D/, '')"
                      autocomplete="off"
                    ></el-input>
                  </el-form-item>
                  <el-form-item prop="password" :rules="passwordRule">
                    <el-input
                      type="password"
                      v-model="form.password"
                      placeholder="Mật khẩu"
                      autocomplete="off"
                    ></el-input>
                  </el-form-item>
                  <el-form-item
                    prop="email"
                    v-show="isRegisterAction"
                    :rules="isRegisterAction ? emailRule : null"
                  >
                    <el-input
                      v-model="form.email"
                      placeholder="Email"
                    ></el-input>
                  </el-form-item>
                </el-form>
                <img
                  class="btn-gif login"
                  v-show="!isRegisterAction"
                  @click="submitAction('2')"
                  src="../assets/new-sport/btn-login.gif"
                />
                <v-captcha
                  ref="vcaptcha2"
                  :dialogVisible="dialogVisible"
                  :showCheck="showCheck"
                  @cb="handleConfirm"
                  :vstyle="{ position: 'absolute', bottom: '-28vw' }"
                  :nativeButton="{
                    width: '40vw',
                    height: '13vw'
                  }"
                >
                  <img
                    class="btn-gif"
                    v-show="isRegisterAction"
                    @click="submitAction('1')"
                    src="../assets/new-sport/btn-register.gif"
                  />
                </v-captcha>
              </div>
              <p class="error-msg">{{ errorMsg.content }}</p>
            </div>
          </div>
        </div>
      </div>
      <div class="occupy-top"></div>
      <div class="game-logos">
        <i class="l" @click="moveLeft()"></i>
        <div class="logos">
          <div class="tt" ref="movingObj">
            <img
              v-for="idx in 5"
              :src="`${require('../assets/new-sport/icon-' + idx + '.png')}`"
            />
          </div>
        </div>
        <i class="r" @click="moveRight()"></i>
      </div>
      <img class="main-register" src="../assets/new-sport/main-register.gif" />
      <div class="contacts">
        <a :href="fb" target="_blank"
          ><img src="../assets/new-sport/icon-fb.png"
        /></a>
        <a :href="tg" target="_blank"
          ><img src="../assets/new-sport/icon-tg.png"
        /></a>
      </div>
    </div>
  </div>
</template>

<script>
import md5 from "js-md5";
import { swiper, swiperSlide } from "vue-awesome-swiper";
import {
  CONTRACTS,
  FORM_VALID_MESSAGE,
  DOMAIN_INVITE_CODE
} from "../utils/constant";
import { userRegister, userLogin, createCustomer } from "../utils/request";
import {
  encodePlatformUrl,
  isMobile,
  validatePhone,
  validateEmail,
  replacePhonePrefix
} from "../utils/tools";
import { captcha } from "@/mixins/captcha";

export default {
  name: "Sport",
  mixins: [captcha],
  components: { swiper, swiperSlide },
  data() {
    return {
      successful: false,
      isMobile: isMobile(),
      formVisible: false,
      swiperMobileVisible: false,
      isRegisterAction: true,
      dialogVisible: false,
      loading: false,
      dialogBgi: require("../assets/sport/bgi-dialog.png"),
      fb: CONTRACTS.facebook,
      tg: CONTRACTS.telegram,
      movingEvent: 0,
      form: {
        by: 1,
        username: "",
        userName: "",
        phone: "",
        password: "",
        email: "",
        link: "",
        domain: "",
        inviteCode: null
      },
      userNameRule: [
        {
          required: true,
          trigger: "change",
          message: FORM_VALID_MESSAGE.emptyMsg
        },
        {
          min: 4,
          max: 20,
          trigger: "change",
          message: FORM_VALID_MESSAGE.usernameFormatErr
        }
      ],
      passwordRule: [
        {
          required: true,
          trigger: "change",
          message: FORM_VALID_MESSAGE.emptyMsg
        },
        {
          min: 6,
          max: 15,
          trigger: "change",
          message: FORM_VALID_MESSAGE.passwordMsg
        }
      ],
      phoneRule: [
        {
          required: true,
          trigger: "change",
          message: FORM_VALID_MESSAGE.emptyMsg
        },
        { validator: validatePhone }
      ],
      emailRule: [
        {
          required: true,
          trigger: "change",
          message: FORM_VALID_MESSAGE.emptyMsg
        },
        {
          trigger: "change",
          validator: validateEmail
        }
      ],
      errorMsg: {
        title: "",
        content: ""
      },
      swiperOptions: {
        speed: 1000,
        loop: true,
        autoplay: {
          disableOnInteraction: false,
          delay: 3000
        }
      }
    };
  },
  mounted() {
    this.swiperMobileVisible = isMobile() && window.innerWidth > 360;
    window.onresize = () => {
      this.isMobile = isMobile();
      this.swiperMobileVisible = this.isMobile && window.innerWidth > 360;
    };
  },
  methods: {
    submitAction(type) {
      let _this = this;
      this.$refs.form.validate(valid => {
        if (valid) {
          _this.loading = true;
          // 登陆
          if (type == 2) {
            let temp = Object.assign({}, this.form);
            let params = {
              acctType: 6,
              by: 1,
              email: temp.email,
              userName: temp.username,
              password: md5(temp.password)
            };
            this.login(params);
          } else {
            const inviteCode = DOMAIN_INVITE_CODE[location.host] || "";
            _this.form.inviteCode = inviteCode;
            _this.form.domain = location.host;
            _this.form.userName = this.form.username;
            _this.register();
          }
        }
      });
    },
    login(params) {
      userLogin(params)
        .then(res => {
          if (res.data.code == 0) {
            this.successful = true;
            this.setDialogMsg("", "");
            setTimeout(() => {
              location.href = encodePlatformUrl(
                this.form.username,
                this.form.password
              );
            }, 5000);
          } else {
            this.$notify({
              title: "Error",
              type: "error",
              duration: 2000,
              message: res.data.msg || "Error!"
            });
          }
          this.loading = false;
        })
        .catch(error => {
          this.$notify({
            title: "Error",
            type: "error",
            duration: 2000,
            message: error.data || "Error!"
          });
          this.loading = false;
        });
    },
    register() {
      this.handleCheck(this.handleConfirm);
    },
    handleConfirm() {
      let params = Object.assign({}, this.form);
      params.userName = params.userName.toLowerCase();
      params.password = md5(params.password);
      params.phone = replacePhonePrefix(params.phone);
      userRegister(params, this.captchaParams)
        .then(res => {
          if (res.data.code == 0) {
            this.successful = true;
            this.setDialogMsg("", "");
            createCustomer(this.form);
            setTimeout(() => {
              location.href = encodePlatformUrl(
                this.form.username,
                this.form.password
              );
            }, 5000);
          } else {
            this.$notify({
              title: "Error",
              type: "error",
              duration: 2000,
              message: res.data.msg || "Error!"
            });
            this.handleOpen(res.data.code);
          }
          this.loading = false;
        })
        .catch(error => {
          this.$notify({
            title: "Error",
            type: "error",
            duration: 2000,
            message: error.data || "Error!"
          });
          this.loading = false;
        });
    },
    closeDialog() {
      this.dialogVisible = false;
    },
    setDialogMsg(title, msg) {
      this.errorMsg.title = title;
      this.errorMsg.content = msg;
      this.dialogVisible = true;
    },
    moveLeft() {
      if (this.movingEvent == 2) return;
      this.movingEvent += 1;
      let t = this.movingEvent == 1 ? "-27.5vw" : "-55vw";
      let s = this.movingEvent == 1 ? "0" : "-27.5vw";
      let dom = this.$refs.movingObj;
      dom.animate(
        { left: [s, t] },
        {
          duration: 500
        }
      );
      setTimeout(() => {
        dom.style.cssText = "left: " + t;
      });
    },
    moveRight() {
      if (this.movingEvent == 0) return;
      this.movingEvent -= 1;
      let t = this.movingEvent == 1 ? "-27.5vw" : "0";
      let s = this.movingEvent == 1 ? "-55vw" : "-27.5vw";
      let dom = this.$refs.movingObj;
      dom.animate(
        { left: [s, t] },
        {
          duration: 500
        }
      );
      setTimeout(() => {
        dom.style.cssText = "left: " + t;
      });
    },
    clickHandler(e) {
      if (
        e.target.className == "content" ||
        e.target.className == "root" ||
        e.target.className == "main-register"
      ) {
        this.formVisible = true;
      } else if (e.target.className == "close") {
        this.formVisible = false;
      }
    }
  }
};
</script>

<style lang="less" scoped>
/deep/ .el-form {
  width: 90%;
  margin-top: 20px;

  ::-webkit-input-placeholder {
    color: #000000 !important;
  }

  .el-input .el-input__inner {
    background: transparent;
    text-indent: 4em;
    color: #000000;
    outline: none;
    text-decoration: none;
    border: none;
  }

  .el-form-item:first-child .el-input {
    background-image: url("../assets/new-sport/bgi-user.png");
    background-size: 100% 100%;
  }

  .el-form-item:nth-child(2) .el-input {
    background-image: url("../assets/new-sport/bgi-phone.png");
    background-size: 100% 100%;
  }

  .el-form-item:nth-child(3) .el-input {
    background-image: url("../assets/new-sport/bgi-pwd.png");
    background-size: 100% 100%;
  }

  .el-form-item:nth-child(4) .el-input {
    background-image: url("../assets/new-sport/bgi-email.png");
    background-size: 100% 100%;
  }
}
.content {
  width: 100%;
  height: calc(100vw * 0.7203125);
  background-image: url("../assets/new-sport/bgi-pc.jpg");
  background-size: 100% 100%;
  display: flex;
  flex-flow: column;
  align-items: center;
  justify-content: center;

  .mask {
    width: 100%;
    height: 100vh;
    position: fixed;
    top: 0;
    left: 0;
    display: flex;
    justify-content: center;
    align-items: center;
    box-sizing: border-box;
    padding-top: 80px;
    background: rgba(0, 0, 0, 0.75);

    .form {
      width: 1195px;
      height: 974px;
      background-image: url("../assets/new-sport/bgi-gorm.png");
      background-size: 100% 100%;
      position: relative;

      .close {
        position: absolute;
        top: 100px;
        right: 0;
        cursor: pointer;
      }

      .form-content {
        width: 515px;
        height: 350px;
        position: absolute;
        right: 255px;
        top: 335px;

        .tags {
          width: 100%;
          display: flex;
          justify-content: center;

          img {
            cursor: pointer;
          }

          img:first-child,
          img:nth-child(2) {
            margin-right: 60px;
          }
        }

        .inputs {
          width: 100%;
          height: 100%;

          .tao {
            width: 85%;
            height: 70%;
            margin: 5px auto 0;
            display: flex;
            flex-flow: column;
            align-items: center;
            position: relative;
          }

          /deep/ .el-form {
            width: 90%;
            margin-top: 20px;

            ::-webkit-input-placeholder {
              color: #000000 !important;
            }

            .el-input .el-input__inner {
              background: transparent;
              text-indent: 4em;
              color: #000000;
              outline: none;
              text-decoration: none;
              border: none;
            }

            .el-form-item:first-child .el-input {
              background-image: url("../assets/new-sport/bgi-user.png");
              background-size: 100% 100%;
            }

            .el-form-item:nth-child(2) .el-input {
              background-image: url("../assets/new-sport/bgi-phone.png");
              background-size: 100% 100%;
            }

            .el-form-item:nth-child(3) .el-input {
              background-image: url("../assets/new-sport/bgi-pwd.png");
              background-size: 100% 100%;
            }

            .el-form-item:nth-child(4) .el-input {
              background-image: url("../assets/new-sport/bgi-email.png");
              background-size: 100% 100%;
            }
          }

          .btn-gif {
            width: 280px;
            height: 85px;
            position: absolute;
            bottom: -180px;
            cursor: pointer;

            &.login {
              bottom: -130px;
            }
          }
        }

        .success-show {
          width: 85%;
          height: 70%;
          margin: 5px auto 0;
          display: flex;
          flex-flow: column;
          align-items: center;
          justify-content: center;

          p {
            width: 80%;
            text-align: center;
          }
        }

        p.error-msg {
          width: 100%;
          margin: 0;
          text-align: center;
        }
      }
    }
  }

  @media only screen and (min-width: 1420px) and (max-width: 1680px) {
    .mid {
      height: 500px !important;
      padding-top: 195px !important;

      img {
        width: 100px !important;
        height: 110px !important;
      }

      img.main-register {
        width: 200px !important;
        height: 45px !important;
      }
    }
  }

  .mid {
    height: 700px;
    padding-top: 275px;
    box-sizing: border-box;
    display: flex;
    flex-flow: column;
    justify-content: space-between;
    align-items: center;

    img.main-register {
      cursor: pointer;
    }
  }

  .contacts {
    position: fixed;
    right: 20px;
    top: 80%;
  }
}

.root {
  width: 100%;
  min-height: 100vh;
  height: calc(100vw * 1.9946);
  background-image: url("../assets/new-sport/bgi-h5.jpg");
  background-size: 100% 100%;
  display: flex;
  flex-flow: column;
  align-items: center;

  .mask {
    width: 100%;
    height: 100vh;
    position: fixed;
    top: 0;
    left: 0;
    z-index: 99;
    display: flex;
    flex-flow: column;
    align-items: center;
    box-sizing: border-box;
    padding-top: 30vw;
    background: rgba(0, 0, 0, 0.75);

    .form {
      width: 100%;
      height: 60vh;
      background-image: url("../assets/new-sport/bgi-form-h5.png");
      background-size: 100% 100%;
      position: relative;

      .close {
        width: 10vw;
        position: absolute;
        left: 47%;
        bottom: -10vw;
      }

      .form-content {
        width: 45%;
        height: 32vh;
        position: absolute;
        left: 28.5%;
        bottom: 7vh;

        .tags {
          width: 100%;
          display: flex;
          justify-content: center;

          img {
            width: 45%;
          }
        }

        .inputs {
          width: 100%;
          height: 100%;

          .tao {
            width: 85%;
            height: 70%;
            margin: 5px auto 8px;
            display: flex;
            flex-flow: column;
            align-items: center;
            position: relative;

            /deep/ .el-form {
              width: 95%;
              margin: 10px;

              .el-form-item__content {
                line-height: 30px;

                .el-input {
                  height: 30px;

                  .el-input__inner {
                    height: 30px;
                    text-indent: 1em;
                  }
                }

                .el-form-item__error {
                  letter-spacing: -0.7px;
                }
              }
            }
          }

          .btn-gif {
            width: 40vw;
            height: 13vw;
            position: absolute;
            bottom: -27vw;
          }
        }

        .success-show {
          width: 85%;
          height: 85%;
          margin: 5px auto 0;
          display: flex;
          flex-flow: column;
          align-items: center;
          justify-content: center;

          img {
            width: 80%;
          }

          p {
            text-align: center;
            font-size: 12px;
          }
        }

        p.error-msg {
          width: 80%;
          margin: 0 auto;
          text-align: center;
          font-size: 0.6em;
        }
      }
    }
  }

  .occupy-top {
    height: 73vw;
  }

  @media screen and (max-width: 414px) and (min-height: 667px) and (max-height: 740px) {
    .occupy-top {
      height: 65vw;
    }
  }

  .game-logos {
    width: 95%;
    height: 30vw;
    margin-bottom: 37vw;
    display: flex;
    justify-content: space-between;
    align-items: center;

    .l {
      width: 6vw;
      height: 11vw;
      background-image: url("../assets/new-sport/icon-l.png");
      background-size: 100% 100%;
    }

    .logos {
      width: 80%;
      height: 100%;
      overflow: hidden;
      position: relative;

      .tt {
        width: 130vw;
        height: 100%;
        display: flex;
        align-items: center;
        justify-content: space-between;
        position: absolute;
        top: 0;
        z-index: 0;

        img {
          width: 20vw;
          height: 23vw;
        }
      }
    }

    .r {
      width: 6vw;
      height: 11vw;
      background-image: url("../assets/new-sport/icon-r.png");
      background-size: 100% 100%;
    }
  }

  .main-register {
    width: 40vw;
  }

  .contacts {
    position: fixed;
    bottom: 0vw;
    right: 11vw;

    img {
      width: 12vw;
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/components/NewSport.vue